import {QuestionBase} from "./question-base";

export class MultiSelectBox extends QuestionBase<string> {
  override controlType = 'multiselectbox';
}
